// extracted by mini-css-extract-plugin
export default {"sidebar":"phase-sidebar_sidebar__tXxea","actions":"phase-sidebar_actions__kA3pY","copy":"phase-sidebar_copy__I7iae","active":"phase-sidebar_active__YNekh"};